import React, { useState } from "react";
import { withRouter } from "react-router";
import { Redirect, Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";

import { subirArchivo } from "../../utils/utilidadesArchivos";
import useObtenerMunicipio from "../../utils/useObtenerMunicipio";

import FormInput from "../components/forminput";
import FormTextArea from "../components/formtextarea";
import MPage from "../templates/mpage";

const FormPresentacion = (props) => {
  const [municipio, error] = useObtenerMunicipio(props.match.params.munUrl);
  const [imagen, guardarImagen] = useState("");
  const [documento, guardarDocumento] = useState("");

  //Estado del formulario
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  //Guarda la imagen cargada en el formulario
  const actualizarImagen = (e) => {
    guardarImagen(e.target.files[0]);
  };

  //Guarda el documento cargado en el formulario
  const actualizarDocumento = (e) => {
    guardarDocumento(e.target.files[0]);
  };

  const onSubmit = (data) => {
    data["municipioId"] = municipio._id;
    data["img"] = "pdefault.svg";
    data["doc"] = "";

    if (imagen.size > 0) {
      const nuevoNombre = subirArchivo(imagen);
      if (nuevoNombre === null) {
        Swal.fire(
          "Ocurrio error al subir la imagen de la propuesta, intente de nuevo."
        );
        return;
      }
      data["img"] = nuevoNombre;
    }

    //Subo el documento adjunto al servidor
    if (documento !== "") {
      const nuevoNombre = subirArchivo(documento);
      if (nuevoNombre === null) {
        Swal.fire(
          "Ocurrio error al subir la documentación anexa, intente de nuevo."
        );
        return;
      }
      data["doc"] = nuevoNombre;
    }

    //Guardo la propuesta
    axios
      .post("/api/propuestas/", data)
      .then(() => {
        //Redireccionar
        Swal.fire(
          "¡Tu propuesta se ha enviado con éxito!",
          "Revisaremos tu propuesta, pronto podrás darle seguimiento desde la página principal.",
          "success"
        );
        props.history.push(`/municipio/${municipio.nombreUrl}`);
      })
      .catch((err) => {
        console.log(err);
        Swal.fire(
          "Ocurrió un error al subir la propuesta, por favor inténtelo de nuevo o pónganse en contacto.",
          "",
          "error"
        );
      });
  };

  if (error === true) return <Redirect to="/" />;

  if (municipio === undefined) return null;
  if (municipio.etapa !== "presentacion") return <Redirect to="/" />;

  return (
    <MPage municipio={municipio}>
      <form className="m-3" onSubmit={handleSubmit(onSubmit)}>
        <h3 className="ppr-titulo mt-3 centrado">
          Formulario de Presentación de Propuesta
        </h3>
        <p className="text-danger mt-1 mb-1">
          Por favor, leer con atención el formulario para que el mismo pueda ser
          completado de manera correcta.
        </p>
        <p className="mt-1 mb-1">
          En la sección &nbsp;
          <Link
            to={"/municipio/" + municipio.nombreUrl + "/info"}
            className="ppr-a"
          >
            MÁS INFORMACIÓN
          </Link>
          &nbsp; encontrarás documentación detallada sobre el presupuesto
          participativo.
        </p>
        <p className="mt-1 mb-1">
          Ante cualquier duda o consulta no dude en comunicarse con nosotros,
          puede encontrar nuestra información de contacto &nbsp;
          <Link
            to={"/municipio/" + municipio.nombreUrl + "/contacto"}
            className="ppr-a"
          >
            HACIENDO CLICK AQUI
          </Link>
          .
        </p>
        <small className=" text-muted">
          Los campos indicados con <b>*</b> son obligatorios.
        </small>
        <hr />
        <h4> Sobre el Autor</h4>

        {(municipio.nombreUrl === "ballesteros2022" ||
          municipio.nombreUrl === "ballesteros2023" ||
          municipio.nombreUrl === "noetinger2022" ||
          municipio.nombreUrl === "corraldebustos2022") && (
          <div className="card mt-3 mb-3">
            <div className="card-header small fondo-celeste">
              MENSAJE IMPORTANTE
            </div>
            <div className="card-body" style={{ whiteSpace: "pre-line" }}>
              Pueden presentar proyectos todas las organizaciones de la sociedad
              civil y otras entidades de la localidad (asociaciones civiles,
              asociaciones simples, fundaciones y organizaciones sin fines de
              lucro, entre otras). Los habitantes de la localidad que posean
              ideas o propuestas deberán trabajar en conjunto con los actores
              mencionados anteriormente para lograr la presentación de sus
              proyectos.
            </div>
          </div>
        )}

        {municipio.nombreUrl !== "ballesteros2022" &&
          municipio.nombreUrl !== "ballesteros2023" &&
          municipio.nombreUrl !== "noetinger2022" &&
          municipio.nombreUrl !== "corraldebustos2022" && (
            <FormInput
              register={register}
              error={errors.autor}
              label={"* Autor:"}
              id={"autor"}
              isRequired={true}
              placeholder="Nombre y apellido del autor o nombre de la organización, según corresponda."
            />
          )}

        {(municipio.nombreUrl === "ballesteros2022" ||
          municipio.nombreUrl === "ballesteros2023" ||
          municipio.nombreUrl === "noetinger2022" ||
          municipio.nombreUrl === "corraldebustos2022") && (
          <FormInput
            register={register}
            error={errors.autor}
            label={"* Nombre de la organización:"}
            id={"autor"}
            isRequired={true}
            placeholder="Nombre de la organización que presenta la propuesta."
          />
        )}

        {municipio.nombreUrl !== "ballesteros2022" &&
          municipio.nombreUrl !== "ballesteros2023" &&
          municipio.nombreUrl !== "noetinger2022" &&
          municipio.nombreUrl !== "corraldebustos2022" && (
            <FormInput
              register={register}
              error={errors.equipo}
              label={"Equipo:"}
              id={"equipo"}
              isRequired={false}
              placeholder="De tratarse de una organización, descripción del equipo."
            />
          )}

        {(municipio.nombreUrl === "ballesteros2022" ||
          municipio.nombreUrl === "ballesteros2023" ||
          municipio.nombreUrl === "noetinger2022" ||
          municipio.nombreUrl === "corraldebustos2022") && (
          <FormInput
            register={register}
            error={errors.equipo}
            label={"* Nombre del representante:"}
            id={"equipo"}
            isRequired={true}
            placeholder="Nombre y apellido del representante de la organización que presenta la propuesta."
          />
        )}

        <FormInput
          register={register}
          error={errors.dni}
          label={"DNI:"}
          id={"dni"}
          isRequired={false}
          placeholder="DNI de quién presenta la propuesta."
          type="number"
        />
        <FormInput
          register={register}
          error={errors.dni}
          label={"Fecha de Nacimiento:"}
          id={"fechaNacimiento"}
          isRequired={false}
          placeholder="Fecha de nacimiento de quién presenta la propuesta."
          type="date"
        />
        <FormInput
          register={register}
          error={errors.email}
          label={"* Email:"}
          id={"email"}
          isRequired={true}
          placeholder="Email de quién presenta la propuesta."
          type="email"
        />
        <FormInput
          register={register}
          error={errors.tel}
          label={"* Teléfono:"}
          id={"tel"}
          isRequired={true}
          placeholder="Teléfono de quién presenta la propuesta, no olvide el código de área.."
          type="tel"
        />
        <FormInput
          register={register}
          error={errors.direccion}
          label={"Dirección:"}
          id={"direccion"}
          isRequired={false}
          placeholder="Dirección de quién presenta la propuesta."
          type="direccion"
        />

        <hr />
        <h4>Sobre la Propuesta</h4>

        <FormInput
          register={register}
          error={errors.titulo}
          label={"* Título:"}
          id={"titulo"}
          isRequired={true}
          placeholder="Título de la propuesta."
        />

        <FormInput
          register={register}
          error={errors.subtitulo}
          label={"* Sub-Título:"}
          id={"subtitulo"}
          isRequired={true}
          placeholder="Sub-título de la propuesta."
        />

        {municipio.ejes.length > 0 && (
          <div className="from-group mb-3">
            <label htmlFor="eje">* Eje de la propuesta:</label>
            <select
              type="text"
              className="form-control"
              id="eje"
              defaultValue="0"
              {...register("eje", {
                validate: (value) => value !== "0",
                required: true,
              })}
            >
              <option key="placeholder" value="0" disabled>
                Seleccione uno de los siguientes ejes para su propuesta.
              </option>
              {municipio.ejes.map((eje) => (
                <option key={eje} value={eje}>
                  {eje}
                </option>
              ))}
            </select>
            {errors.eje && (
              <small className="text-danger form-text">
                Campo Obligatorio.
              </small>
            )}
          </div>
        )}

        <FormInput
          register={register}
          error={errors.presupuesto}
          label={"* Presupuesto:"}
          id={"presupuesto"}
          isRequired={true}
          placeholder="Monto aproximado para ejecutar la propuesta."
          type="number"
        />

        <FormTextArea
          register={register}
          error={errors.objetivos}
          label={"* Objetivos:"}
          id={"objetivos"}
          isRequired={true}
          placeholder="Detallar, de forma clara y concreta, el propósito principal que se espera alcanzar con la propuesta. Debe responder con precisión a la pregunta: “¿Qué se quiere lograr con este proyecto?”"
          rows={10}
        />

        <FormTextArea
          register={register}
          error={errors.beneficiarios}
          label={"* Beneficiarios:"}
          id={"beneficiarios"}
          isRequired={true}
          placeholder="Describir a quién o quiénes se dirige la propuesta, identificando el grupo o sector que será impactado de forma directa."
          rows={10}
        />

        <FormTextArea
          register={register}
          error={errors.laccion}
          label={"* Lugar de acción:"}
          id={"laccion"}
          isRequired={true}
          placeholder="Indicar la ubicación o área geográfica en donde se desarrollará la propuesta."
          rows={1}
        />

        <FormTextArea
          register={register}
          error={errors.resultados}
          label={"* Resultados esperados:"}
          id={"resultados"}
          isRequired={true}
          placeholder="Enunciar los beneficios tangibles e intangibles que se obtendrán con la implementación del proyecto."
          rows={10}
        />

        <FormTextArea
          register={register}
          error={errors.pejecucion}
          label={"* Periodo de ejecución:"}
          id={"pejecucion"}
          isRequired={true}
          placeholder="Indicar la duración estimada de la propuesta en meses."
          rows={1}
        />

        <FormTextArea
          register={register}
          error={errors.descripcion}
          label={"* Descripción:"}
          id={"descripcion"}
          isRequired={true}
          placeholder="Descripción lo más detallada posible sobre la propuesta.."
          rows={10}
        />

        <FormInput
          register={register}
          error={errors.doc}
          label={"Documentación (un archivo pdf):"}
          id={"doc"}
          isRequired={false}
          placeholder="Documento en pdf que se adjunta a la propuesta."
          type="file"
          accept="application/pdf,application/vnd.ms-excel"
          onChange={actualizarDocumento}
        />

        <FormInput
          register={register}
          error={errors.doc}
          label={"Imagen (.jpg o .png)::"}
          id={"img"}
          isRequired={false}
          placeholder="Imagen que se adjunta a la propuesta."
          type="file"
          accept="image/png, image/jpeg"
          onChange={actualizarImagen}
        />

        <center>
          <button
            type="submit"
            className="btn ppr-btn-verde font-weight-bold m-2 mr-5"
          >
            Presentar
          </button>
          <Link
            to={"/municipio/" + municipio.nombreUrl}
            className="btn ppr-btn-verde font-weight-bold m-2"
          >
            Volver
          </Link>
        </center>
      </form>
    </MPage>
  );
};

export default withRouter(FormPresentacion);
